export const JSA_PROFILE_TASK_DETAIL_TILE_TYPE = 'v1.jsa.profile-task.detail' as const;
